//'development' 开发版本 'production'  生产版本
//演示http://web.cnuip.net   正式https://mist.idpc.org.cn
export const baseUrl = process.env.NODE_ENV === 'development' ? '/api' : '/api'
export const indexUrl = process.env.NODE_ENV === 'development' ? '/test-api' : '/api'



// WEBPACK FOOTER //
// ./src/plugins/http/baseUrl.js